import React, { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';

import { CustomModal } from '../../../components/CustomModal';
import { BLOCK, BLOCK_USER_TITLE, RESTORE, RESTORE_USER_TITLE } from '../../../helpers/constants';

interface Props {
  closeModal(): void;
  handlerUpdate(): void;
  getUserStatus: boolean;
}

export const UpdateUserModal: FC<Props> = ({ getUserStatus, closeModal, handlerUpdate }) => {
  const getTitleModal = (): string => {
    if (!getUserStatus) {
      return RESTORE_USER_TITLE;
    }
    return BLOCK_USER_TITLE;
  };
  return (
    <CustomModal title={getTitleModal()} handleClose={closeModal} open={true}>
      <Stack flexDirection="row" mt={5}>
        <Button
          onClick={closeModal}
          variant="contained"
          color="info"
          style={{
            width: '80%',
            height: '95%',
            marginRight: '2px',
          }}
        >
          <Typography>Отмена</Typography>
        </Button>
        <Button
          onClick={handlerUpdate}
          variant="contained"
          style={{
            width: '80%',
            height: '95%',
            marginLeft: '2px',
            background: getUserStatus ? '#DD4646' : '#70BF2B',
          }}
        >
          <Typography>{getUserStatus ? BLOCK : RESTORE}</Typography>
        </Button>
      </Stack>
    </CustomModal>
  );
};
